















































































import Vue from "vue";
import moment from "moment";

import { MODULE_COLORS } from "@/utility/Constants";

import { RestoreBackupCommand, RestoreBackupReqData } from "@/model/communication/caosConfiguration/RestoreBackupCommand";
import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";
import { ApiGenericResponse } from "@/model/communication/ApiGenericResponse";
import { ADD_ALERT } from "@/store/modules/AlertModule/mutations";
import { mapMutations } from "vuex";
import { AlertModel, AlertModelType } from "@/store/modules/AlertModule/types";
import { CaosConfigurationBackup } from "@/model/data/caosConfiguration/CaosConfigurationBackup";

export default Vue.extend({
    props: { showDialog: Boolean, backups: Array as () => Array<CaosConfigurationBackup>, loading: Boolean, installation: String },
    data() {
        return {
            moment,
            MODULE_COLORS,
            loadingRestoreBackup: false,
            selectedBackup: null,
            showMore: false,
            showBackupNum: 5,
        };
    },
    computed: {
        showRestoreBackupDialog: {
            get() {
                return this.showDialog;
            },
            set(newValue: boolean) {
                this.$emit("update:showDialog", newValue);
                this.selectedBackup = null;
                this.showMore = false;
            },
        },

        editedBackups() {
            if (this.backups == null || this.backups == undefined || !this.backups.length) return [];
            if (this.showMore || this.backups.length < this.showBackupNum) return this.backups;
            else return this.backups.slice(this.backups.length - this.showBackupNum, this.backups.length);
        },
    },
    methods: {
        ...mapMutations([ADD_ALERT]),

        async sendRequestRestoreBackup() {
            this.loadingRestoreBackup = true;
            let response: ApiGenericResponse = await new RestoreBackupCommand(new RestoreBackupReqData(this.selectedBackup)).execute();
            let endingMessage = "";
            let alertType = AlertModelType.Error;
            if (response.responseStatus == ApiResponseStatusEnum.Success && response.responseString != "GenericError") {
                alertType = AlertModelType.Success;
                endingMessage = this.$t("caosConfig.restoreBackupSuccess", { name: this.installation });
            } else {
                endingMessage = this.$t("caosConfig.restoreBackupError", { name: this.installation }) + ".";
                if (response.message == "DeviceLocked") endingMessage += this.$t("caosTemplate.deviceBusyError");
                else if (response.message == "AgentOffline") endingMessage += this.$t("caosTemplate.agentOfflineForInstallation", { task: "restore a backup" });
                else endingMessage += " " + this.$t("caosConfig.restoreBackupRequirements");
            }
            this[ADD_ALERT](new AlertModel(alertType, endingMessage));
            this.loadingRestoreBackup = false;
            this.showRestoreBackupDialog = false;
        },
    },
});
